const { VITE_BACKEND_URL } = import.meta.env;

export async function fetchResult(body: Object) {
    const payload = JSON.stringify(body)
    console.log('Submitting payload', JSON.parse(payload))
    try {
      const response = await fetch(VITE_BACKEND_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: payload
      })
      if (response.status === 200) {
        const data = await response.json()
        return data["result"];
      }
    } catch {
        return null;
    }
}
